import { DEFAULT_SHIFT_SETTINGS } from '..'
import { ViewShift } from '../../models'

export const DEFAULT_SHIFT: Omit<ViewShift, 'id'> = {
  name: 'Neue Schicht',
  active: false,
  isHoliday: false,
  isTimeFrameOptional: true,
  from: new Date(),
  until: new Date(),
  weekdays: [],
  timeslots: [],
  settings: DEFAULT_SHIFT_SETTINGS,
  rooms: [],
  order: 0,
}
